import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import { GraphicsOptions } from "../../component_graphics/data/componentGraphicsData";
import GalleryHTMLInput from "./GalleryHTMLInput";
import GalleryImageInput from "./GalleryImageInput";
import GalleryVideoInput from "./GalleryVideoInput";

interface Props {
  item: any;
  saveContentInStore: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  keyProp: number;
  toggleNewEditionsDetected: (value: boolean) => void;
  saveImageInfoInDB: any;
  removeImageFromDB: any;
  state: any;
}

const GalleryGraphicsOptions = (props: Props): JSX.Element => {
  const {
    item,
    saveContentInStore,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
    saveImageInfoInDB,
    removeImageFromDB,
    state,
  } = props;

  const isCurrentActiveOptionValid = Object.keys(GraphicsOptions).includes(
    state.activeOption
  );
  const activeOption: GraphicsOptions = isCurrentActiveOptionValid
    ? state.activeOption
    : GraphicsOptions.image;

  const mapInputsToGraphicsOption: {
    [key in GraphicsOptions]: JSX.Element;
  } = {
    [GraphicsOptions.image]: (
      <GalleryImageInput
        item={item}
        saveContentInStore={saveContentInStore}
        contentType={contentType}
        currentInputData={currentInputData}
        keyProp={keyProp}
        toggleNewEditionsDetected={toggleNewEditionsDetected}
        saveImageInfoInDB={saveImageInfoInDB}
        removeImageFromDB={removeImageFromDB}
      />
    ),
    [GraphicsOptions.video]: (
      <GalleryVideoInput
        saveContentInStore={saveContentInStore}
        contentType={contentType}
        currentInputData={currentInputData}
        keyProp={keyProp}
        toggleNewEditionsDetected={toggleNewEditionsDetected}
        item={item}
      />
    ),
    [GraphicsOptions.HTML]: (
      <GalleryHTMLInput
        saveContentInStore={saveContentInStore}
        contentType={contentType}
        currentInputData={currentInputData}
        keyProp={keyProp}
        toggleNewEditionsDetected={toggleNewEditionsDetected}
        item={item}
      />
    ),
  };

  return mapInputsToGraphicsOption[activeOption];
};

export default GalleryGraphicsOptions;
